import assets from "assets";
import axios from "axios";
import { PrimaryButton } from "components/Button";
import Column from "components/Column";
import { HorizontalDivider } from "components/Divider/inde";
import { StyledInput } from "components/Input/TextField";
import { CircledImageCtr } from "components/Logo";
import QuestionHelper from "components/QuestionHelper";
import Row from "components/Row";
import { useOnClickOutside } from "hooks/useOnClickOutside";
import useTheme from "hooks/useTheme";
import { color } from "html2canvas/dist/types/css/types/color";
import React, { useRef, useState } from "react";
import { File, FileText, XCircle } from "react-feather";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { Form } from "react-router-dom";
import { Button } from "rebass";
import { updateUserHoldNFTStatus } from "store/user/actions";
import { useToGetUserInfo } from "store/user/hooks";
import styled from "styled-components";
import { TEXT } from "theme/texts";


const NFTBuyPopup = ({
  hidePopup,
  showPopup,
}: {
  hidePopup: () => React.Dispatch<React.SetStateAction<boolean>>;
  showPopup: boolean;
}) => {
  const { wallet } = useToGetUserInfo();
  const [enableForm, setEnableForm] = useState(false);
  const [email, setEmail] = useState<string | null>(null);
  const [scode, setCode] = useState<string | null>(null);

  const formRef = useRef<HTMLFormElement>(null);
  const formRefcode = useRef<HTMLFormElement>(null);

  const node = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const theme = useTheme();
  const switchFormVisibilityStatus = () => {
    if (enableForm) {
      formRef?.current?.reset();
    }
    setEnableForm((prev) => !prev);
  };
  const PostData = async (email: any, wallet: string) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/earlyAccess`,
        {
          email: email,
          wallet: wallet,
        }
      );
      console.log(res);
      hidePopup();
      formRef?.current?.reset();
      toast.success("Email submitted successfully!");
    } catch (error) {
      console.log(error);
      toast.error("Email submission failed!");
    }
  };
  const PostCodeData = async (email: any, wallet: string) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/earlyAccess`,
        {
          code: scode,
          wallet: wallet,
        }
      );
      console.log(res);
      hidePopup();
      formRef?.current?.reset();
      toast.success(" Secret Code submitted successfully!");
    } catch (error) {
      console.log(error);
      toast.error(" Secret Code submission failed!");
    }
  };
  const onCodeFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    PostCodeData(scode, wallet);
  };
  const onFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    PostData(email, wallet);
  };
  // useOnClickOutside(node, hidePopup);
  //prevent page scroll
  React.useEffect((): any => {
    if (showPopup) {
      document.body.style.overflow = "hidden";
      return () => (document.body.style.overflow = "scroll");
    }
  }, [showPopup]);

  return showPopup ? (
    <NFTBuyPopupWrapper>
      <PopupCtr ref={node}>
        <Row style={{ justifyContent: "space-between" }}>
          <QuestionHelper text="You must hold the Access Pass NFT to use the website." />

          <XCircle onClick={() => hidePopup()} style={{cursor: "pointer"}} />
        </Row>
        <Column
          style={{ alignItems: "center", gap: ".5rem", textAlign: "center" }}
        >
          {/* <FileText size="125px" color={theme.disabledVar3} /> */}
          <img src={assets.images.formImg} alt="" className="img" />
          <TEXT.SmallHeader color={"#787878"}>
          Oops, you don't have any partner NFT
          </TEXT.SmallHeader>
          {/* <a
            href="http://"
            target="_blank"
            rel="noopener noreferrer"
            className="link"
            style={{ color: "#4477FF" }}
          >
            Check here for list
          </a> */}
          {/* <PrimaryButton
            onClick={() =>
              window.open(
                "https://opensea.io/collection/surfaceboard-genesis-pass",
                "_blank"
              )
            }
            style={{ borderRadius: ".5rem", fontFamily: "var(--ff-subtitle)" }}
          >
            Get a Genesis Pass
          </PrimaryButton> */}
        </Column>

        <CheckBtn>
          {/* <input
            type="checkbox"
            name="checkbox"
            onChange={switchFormVisibilityStatus}
          />
          <span className="checkbox"></span> */}
        </CheckBtn>
        <span className="label">Sign up for Waitlist</span>

        <PopupForm
          onSubmit={onFormSubmit}
          ref={formRef}
          style={{ display: "flex" }}
        >
          <StyledInput
            type={"email"}
            placeholder={"Enter Email Address"}
            required
            style={{ borderRadius: ".5rem" }}
            // disabled={!enableForm}
            onChange={(e) => setEmail(e.target.value)}
          />
          <PrimaryButton
            style={{
              borderRadius: ".5rem",
              fontFamily: "var(--ff-subtitle)",
              width: "100px",
            }}
            // disabled={!enableForm}
          >
            Submit
          </PrimaryButton>
        </PopupForm>
        <Row>
          <HorizontalDivider />
          <TEXT.SmallBody
            textAlign={"center"}
            color={theme.disabled}
            margin={"0 .85rem 0 .5rem"}
          >
            or
          </TEXT.SmallBody>
          <HorizontalDivider />
        </Row>
        <div>
          <PopupForm
            onSubmit={onCodeFormSubmit}
            ref={formRefcode}
            style={{ display: "flex" }}
          >
            <StyledInput
              type={"text"}
              placeholder={"Enter Secret Code to Skip"}
              required
              style={{ borderRadius: ".5rem" }}
              // disabled={!enableForm}
              onChange={(e) => setCode(e.target.value)}
            />
            <PrimaryButton
              style={{
                borderRadius: ".5rem",
                fontFamily: "var(--ff-subtitle)",
                width: "100px",
              }}
              // disabled={!enableForm}
            >
              Submit
            </PrimaryButton>
          </PopupForm>
          <a className="small" href="https://www.producthunt.com/posts/surfaceboard"> 👀 Get my Secret Code</a>
        </div>

        <div className="wrapper">
          <a
            className="opensea"
            href="https://opensea.io/collection/surfaceboard-genesis-pass"
            target="_blank"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.95444 6.10352e-05C3.73691 6.10352e-05 0.316284 3.42068 0.316284 7.63822C0.316284 11.8558 3.73691 15.2764 7.95444 15.2764C12.172 15.2764 15.5926 11.8558 15.5926 7.63822C15.5926 3.42068 12.1739 6.10352e-05 7.95444 6.10352e-05ZM4.08444 7.89473L4.1169 7.84318L6.10473 4.73445C6.11139 4.72423 6.12067 4.71598 6.13161 4.71058C6.14254 4.70517 6.15472 4.7028 6.16688 4.70371C6.17905 4.70462 6.19074 4.70878 6.20075 4.71575C6.21075 4.72273 6.2187 4.73226 6.22376 4.74336C6.55475 5.48744 6.84245 6.41293 6.70751 6.98898C6.6515 7.22576 6.49428 7.54656 6.31669 7.84318C6.29391 7.88657 6.26906 7.92884 6.24222 7.96984C6.23579 7.97899 6.22719 7.9864 6.21719 7.99139C6.20719 7.99639 6.19611 7.99883 6.18494 7.99849H4.14364C4.13145 7.99867 4.11945 7.99556 4.10889 7.98947C4.09833 7.98338 4.08962 7.97455 4.08368 7.96391C4.07774 7.95327 4.0748 7.94122 4.07515 7.92904C4.07551 7.91686 4.07916 7.90501 4.08572 7.89473H4.08444ZM12.9409 8.96408C12.941 8.97767 12.9372 8.991 12.9299 9.00243C12.9225 9.01386 12.9119 9.02288 12.8995 9.02836C12.7448 9.09392 12.2184 9.33707 11.9995 9.64069C11.4406 10.4185 11.0142 11.5311 10.0594 11.5311H6.07864C5.74254 11.5306 5.40983 11.4639 5.09953 11.3348C4.78922 11.2056 4.50741 11.0166 4.2702 10.7785C4.03298 10.5404 3.84501 10.2579 3.71703 9.9471C3.58904 9.63632 3.52356 9.30336 3.52431 8.96726V8.92143C3.52431 8.88451 3.55486 8.85396 3.59305 8.85396H5.8113C5.85586 8.85396 5.88768 8.89406 5.8845 8.93798C5.86795 9.08183 5.89532 9.23014 5.96407 9.36444C6.09519 9.63178 6.36889 9.79854 6.66359 9.79854H7.76222V8.94116H6.67505C6.66231 8.94103 6.64985 8.93742 6.63901 8.93073C6.62817 8.92403 6.61936 8.91451 6.61353 8.90318C6.60771 8.89185 6.60508 8.87915 6.60594 8.86644C6.60679 8.85372 6.6111 8.84149 6.6184 8.83104L6.6585 8.77376C6.76034 8.62672 6.90738 8.40076 7.05378 8.14234C7.15307 7.96793 7.24982 7.78207 7.32748 7.59494C7.34275 7.56184 7.35485 7.52683 7.36885 7.49309C7.38985 7.43326 7.4115 7.37725 7.42677 7.32187C7.44176 7.27492 7.45556 7.22759 7.46815 7.17993C7.50443 7.0208 7.5197 6.85276 7.5197 6.67899C7.5197 6.61025 7.51716 6.53832 7.51079 6.47085C7.50761 6.39638 7.49806 6.32127 7.48915 6.2468C7.48203 6.18017 7.47184 6.1139 7.4586 6.04821C7.44147 5.94818 7.42066 5.84882 7.39622 5.75032L7.38731 5.71213C7.36821 5.64339 7.35166 5.57846 7.33002 5.51036C7.26941 5.3012 7.19976 5.09478 7.12125 4.89166C7.09389 4.81526 7.06374 4.73989 7.03086 4.6657C6.98503 4.5524 6.93793 4.44992 6.89528 4.35381C6.87406 4.31263 6.85411 4.27082 6.83545 4.22842C6.81475 4.18268 6.79289 4.13747 6.76989 4.09284C6.75461 4.05911 6.73616 4.02664 6.72406 3.99609L6.58976 3.74912C6.5713 3.71539 6.60185 3.67402 6.63877 3.68484L7.47897 3.91207H7.48533L7.59545 3.9439L7.71766 3.97827L7.76222 3.99036V3.49197C7.76222 3.25073 7.95444 3.05532 8.19441 3.05532C8.25107 3.05517 8.30718 3.06648 8.35936 3.08858C8.41154 3.11068 8.4587 3.1431 8.49802 3.1839C8.57929 3.26587 8.62503 3.37654 8.62533 3.49197V4.23287L8.71508 4.2577C8.72144 4.26088 8.72908 4.26406 8.73481 4.26852C8.75645 4.28379 8.78827 4.30798 8.82837 4.33853C8.8602 4.36272 8.89394 4.39327 8.9334 4.42574C9.05909 4.52814 9.18096 4.63515 9.29876 4.74654C9.43497 4.87321 9.58774 5.02151 9.73413 5.18637C9.77551 5.23347 9.81497 5.2793 9.85634 5.33022C9.89581 5.38051 9.94036 5.42952 9.97728 5.47789C10.0276 5.54409 10.0791 5.61283 10.1269 5.68412C10.1479 5.71786 10.174 5.75287 10.1937 5.7866C10.2548 5.87699 10.307 5.96992 10.3573 6.06349C10.3789 6.10613 10.3999 6.15323 10.4184 6.19906C10.475 6.32446 10.5196 6.45112 10.547 6.5797C10.556 6.60699 10.5622 6.63515 10.5654 6.66372V6.67008C10.5743 6.70636 10.5775 6.74646 10.5807 6.7872C10.5986 6.97533 10.5756 7.16512 10.5132 7.34351C10.4935 7.39698 10.475 7.45172 10.4508 7.50519C10.4031 7.6134 10.3484 7.72351 10.2828 7.82472C10.2612 7.86291 10.2351 7.90237 10.2109 7.94056C10.1835 7.98066 10.1542 8.01885 10.13 8.05513C10.095 8.10333 10.0583 8.15026 10.0199 8.1958C9.98619 8.24163 9.95246 8.28746 9.91427 8.32884C9.86271 8.39121 9.81242 8.44977 9.75832 8.50579C9.72777 8.5427 9.69467 8.5809 9.65903 8.61399C9.62593 8.65218 9.59028 8.68592 9.55973 8.71647C9.50626 8.76994 9.46425 8.81004 9.42733 8.84505L9.34013 8.9227C9.32799 8.93489 9.31151 8.94176 9.2943 8.9418H8.62533V9.79854H9.4668C9.65457 9.79854 9.83343 9.73235 9.97855 9.60886C10.0276 9.56622 10.2427 9.37972 10.4979 9.09838C10.5063 9.0888 10.5174 9.08212 10.5298 9.07928L12.853 8.40649C12.8632 8.40354 12.874 8.40299 12.8844 8.40489C12.8949 8.40679 12.9048 8.41109 12.9133 8.41744C12.9218 8.42379 12.9287 8.43202 12.9335 8.4415C12.9383 8.45098 12.9408 8.46143 12.9409 8.47205V8.96408Z"
                fill="white"
              />
            </svg>
            Check on OpenSea
          </a>
        </div>
      </PopupCtr>
    </NFTBuyPopupWrapper>
  ) : null;
};

const CheckBtn = styled.label`
  --size: 1.15rem;
  --border: 0.1rem;

  input[type="checkbox"] {
    appearance: none;
    position: relative;
  }

  .checkbox {
    position: absolute;
    height: var(--size);
    border-radius: 5px;
    border: var(--border) solid white;
    width: var(--size);
    transition: 100ms ease-in;
    cursor: pointer;
  }

  input:checked + .checkbox {
    background: ${({ theme }) => theme.btnPrimary};
    border: var(--border) solid #fff;
  }
`;
const PopupForm = styled.form`
  display: grid;
  gap: 1rem;
`;
const PopupCtr = styled(Column)`
  width: 95%;
  max-width: 390px;
  padding: 2rem;
  padding-bottom: 2rem;
  background: ${({ theme }) => theme.bgFooter};
  border-radius: 0.5rem;
  gap: 1rem;
`;
const NFTBuyPopupWrapper = styled(Column)`
  .label {
    margin-bottom: 10px;
    font-family: var(--ff-subtitle);
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
  }
  .small {
    font-weight: 500;
    font-size: 0.7rem;
    line-height: 24px;
    font-family: var(--ff-subtitle);
    margin-top: 12px;
    color: #fff;
    text-decoration: none;
  }
  .link {
    font-size: 12px;
  }
  .wrapper {
    width: 100%;
    margin-top: 30px;
  }
  .opensea {
    margin: 0 auto;
    cursor: pointer;
    width: fit-content;
    font-weight: 500;
    font-size: 10.1842px;
    line-height: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    text-decoration: none;
    color: #fff;
  }
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background: rgb(18, 18, 18, 0.7);
  z-index: 100000000000000000;
`;
export default NFTBuyPopup;
